import type {AnyFieldApi} from "@tanstack/react-form";

/**
 * Extracts error messages from a TanStack React Form field.
 * @param field - The field API from TanStack React Form.
 * @returns A string containing the error messages for the field, or a validation message if the field is currently validating.
 */
export const getErrorText = (field: AnyFieldApi) =>
  field.state.meta.errors.map((error) => error.message).join(" ") ||
  (field.state.meta.isValidating ? "Ověřuji..." : "");
